import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

/**
 * Sanfter Seitenwechsel: Scroll zurücksetzen + kurzer Fade-In beim Routenwechsel.
 */
export function PageTransition() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      prevPath.current = location.pathname;
    }
  }, [location.pathname]);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const onEnd = (event: AnimationEvent) => {
      if (event.target !== el) return;
      // Transform vom Enter entfernen, damit fixed-Positionierung am Viewport greift.
      el.classList.remove("eh-page-enter");
    };
    el.addEventListener("animationend", onEnd);
    return () => el.removeEventListener("animationend", onEnd);
  }, [location.pathname]);

  return (
    <div key={location.pathname} ref={rootRef} className="eh-page-enter min-w-0 max-w-full">
      <Outlet />
    </div>
  );
}
